import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { EditorState, ContentState, convertFromRaw } from 'draft-js';
export var getStateFromLocal = function getStateFromLocal(name) {
  var localData = typeof localStorage !== 'undefined' ? localStorage.getItem(name) : null;
  if (localData) {
    try {
      var data = JSON.parse(localData);
      if (data.timestamp && data.content) {
        var seconds = Math.floor((new Date() - new Date(data.timestamp)) / 1000);
        if (seconds > 180) throw new Error('Too old');
        var content = JSON.parse(data.content);
        var contentState = convertFromRaw(content);
        if (contentState.getPlainText().replace(/\s/g, '') === '' && contentState.getBlockMap().size === 1) {
          throw new Error('Empty content');
        }
        return EditorState.moveSelectionToEnd(EditorState.createWithContent(contentState));
      }
    } catch (err) {
      localStorage.removeItem(name);
      return EditorState.createEmpty();
    }
  }
  return EditorState.createEmpty();
};
export var getStateFromProps = function getStateFromProps(content) {
  var data;
  if (content.type === 'blocks') {
    try {
      var raw = JSON.parse(content.body);
      data = convertFromRaw(raw);
    } catch (err) {
      return EditorState.createEmpty();
    }
  }
  if (content.type === 'plain') {
    data = ContentState.createFromText(content.body);
  }
  return data ? EditorState.createWithContent(data) : EditorState.createEmpty();
};